import '../sass/index.scss'; // To compile all the styles

import './components/bb-rs-master';
import './components/core';
import './components/google-maps';

jQuery(document).ready(function ($) {
	$(document).click(function (event) {
		if (
			!$(event.target).is(
				'.review-button, .reviews-pullout, .pullout-body, .reviews-widget-wrapper, .review-footer'
			)
		) {
			$('.reviews-pullout').removeClass('active');
		}
	});

	$('.review-button').on('click', function () {
		$('.reviews-pullout').toggleClass('active');
	});
});
